const COOKIE_CONSENT_STORAGE_KEY = 'cian_jobs_cookie_consent';
const COOKIE_CONSENT_VALUE = 'accepted';

export function isCookieConsentAccepted(): boolean {
  try {
    return window.localStorage.getItem(COOKIE_CONSENT_STORAGE_KEY) === COOKIE_CONSENT_VALUE;
  } catch {
    return false;
  }
}

export function acceptCookieConsent(): void {
  try {
    window.localStorage.setItem(COOKIE_CONSENT_STORAGE_KEY, COOKIE_CONSENT_VALUE);
  } catch {
    /* localStorage is unavailable — ignore */
  }
}
